import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ConversationPage } from "@/domains/conversation";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ConversationsIndex',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(ConversationPage), { class: "h-full" }));
        };
    }
});
